export default "__VITE_PUBLIC_ASSET__6d1fdb65__"